import React from "react";
import axios from "axios";
import Urls from "../Urls";
import RefreshTokenReq from "../Requester/RefreshTokenReq";
import { DefaultLang } from "../../Utility/DefaultLang";
import LocalToken from "../Method/LocalToken";
// import SecurityManager from "../Default/SecurityManager"
import Cookies from "js-cookie";

export let inRefresh = false;
let requestList = [];
let baseurl = Urls.api();
const publicUrlList = [
  Urls.AppConfig(),
  Urls.teacherProfilePublic(),
  Urls.login(),
  Urls.teacherList(),
  Urls.SendEmailVerifyCode(),
  Urls.SendPhoneVerifyCode(),
  Urls.EmailVerifyCode(),
  Urls.PhoneVerifyCode(),
  Urls.StudentRegisterByEmail(),
  Urls.StudentRegisterByPhone(),
  Urls.TeacherRegisterByPhone(),
  // Urls.teacherResume(),
  Urls.teacherLessons(),
  // Urls.teacherWeekly(),
  // Urls.teacherProfile(),
  Urls.teacherAvailability(),
];
let token = LocalToken.Get();
export const axiosInstance = axios.create({
  baseurl,
});
axiosInstance.interceptors.request.use(
  function (config) {
    if (!publicUrlList.includes(config.url)) {
      config.headers = {
        Authorization: LocalToken.Get()
          ? `Bearer ${LocalToken.Get().accToken}`
          : "",
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { config, response } = error;
    const originalRequest = config;
    if (error.response === undefined || error.response.status === 401) {
      if (!inRefresh) {
        // console.log('Refresh 1');

        inRefresh = true;
        RefreshTokenReq()
          .then((res) => {
            inRefresh = false;
            LocalToken.Set(res);

            Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
            Cookies.set("LINGO_REFRESH_TOKEN", res.data.RefreshToken);
            // console.table(res.data.AccessToken, LocalToken.Get().accToken, res.data.RefreshToken, LocalToken.Get().refToken);
            // setTimeout(() => {
            onRefresh(res.data.AccessToken);
            // }, 1)
            requestList = [];
          })
          .catch((err) => {
            if (err.response) {
              if (
                error.response === undefined ||
                error.response.status === 401
              ) {
                // console.log('Refresh 2');

                RefreshTokenReq()
                  .then((res) => {
                    // console.log('Refresh 3 get new token');

                    inRefresh = false;
                    LocalToken.Set(res);

                    Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                    Cookies.set("LINGO_REFRESH_TOKEN", res.data.RefreshToken);
                    onRefresh(res.data.AccessToken);
                    requestList = [];
                  })
                  .catch((error) => {
                    // if (error.response.status === 403) {
                    // }
                    if (
                      (error.response === undefined ||
                        error.response.status) === 401 &&
                      token
                    ) {
                      // console.log('Ref Err');
                      localStorage.clear();
                      window.location.replace("/");
                    }
                  });
              }
            }
          });
      }
      const retryOrigReq = new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers["Authorization"] = "Bearer " + token;
          resolve(axiosInstance(originalRequest));
        });
      });
      return retryOrigReq;
    } else {
      return Promise.reject(error);
    }
  }
);
const subscribeTokenRefresh = (request) => {
  requestList.push(request);
};
const onRefresh = (accToken) => {
  requestList.map((request) => request(accToken));
};
